import React           from 'react';
import Grid            from './Grid';
import { appsType }    from '../../types';
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        height:          '100vh',
       // width:           '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        display:         'flex',
        flexFlow:        'column',
    },
    title: {
        fontWeight: 'bold'
    },
    text: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center'
    },
    navbar: {
        height:          150,
        width:           '100%',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
    }
}))

type appsProps = {
    size:                   number[];
    navbarSize:             number;
    lang:                   string;
    variant:                string;
    userRole:               string;
    wideScreen:             boolean;
    appsArr:                appsType[];
    handleAppClick:         (val: number) => void;
    handleStudentInfoClick: (val: string[]) => void;
}
const Apps: React.FC<appsProps> = ({ 
    size,
    navbarSize,
    lang,
    variant,
    userRole,
    wideScreen,
    appsArr,
    handleAppClick,
    handleStudentInfoClick
}) => {

  const classes = useStyles();

  const width = React.useMemo(() => {
       return wideScreen ? size[0] - navbarSize : size[0]
  },[size, navbarSize, wideScreen])

  return (
    <div 
       className = { classes.root }
       style     = {{
           width: width
       }}
    >
        <Grid 
           width                  = { width }
           lang                   = { lang }
           variant                = { variant }
           size                   = { size }
           userRole               = { userRole }
           appsArr                = { appsArr }
           handleAppClick         = { handleAppClick }
           handleStudentInfoClick = { handleStudentInfoClick }
        />
    </div>
  );
}




export default Apps;

